import React from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';
import { useTranslation } from 'react-i18next';

import { useLocation, useNavigate } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

import { useStore } from '@modules';

import LoaderLayout from '@layouts/LoaderLayout';
import WalletLayout from '@layouts/WalletLayout';

import { BillingAddressForm } from './BillingAddressForm';

import style from './BillingAddress.scss';

const cn = bemCssModules(style, 'BillingAddress');

const BillingAddress: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation<LocationStateType['billingAddress']>();
  const { state } = location;
  const [{ user, global }] = useStore();
  const userData = user.data;
  const countries = global.countries;

  const onBack = () => navigate(state?.from || CONST.nav.profileEdit);

  const isLoading =
    user.loaders.getUserData && !userData && global.loaders.getCountries && !countries.length;

  return (
    <WalletLayout
      header={<div className={cn('header')}>{t('common.billing_address_title')}</div>}
      backButton={onBack}
      hasSidebar={false}
      className={cn(null, [className])}
    >
      <div className={cn('container', [className])}>
        <p className={cn('description')}>{`${state?.notificationData?.message || ''}${t(
          'common.billing_address_subtitle'
        )}`}</p>

        <LoaderLayout isLoading={isLoading}>
          <BillingAddressForm />
        </LoaderLayout>
      </div>
    </WalletLayout>
  );
};

export default BillingAddress;
